/**
 * Thin wrapper around the design-system CSS tooltip ({@link Tooltip}) for the
 * Design tab. Native `title=` tooltips are unreliable here — TipTap and the
 * item editor re-render constantly, and Chromium drops the title mid-hover and
 * won't show it again. The peer/CSS tooltip is render-stable and styled.
 *
 * Usage: wrap a single trigger that carries the `peer` class —
 *   <Tip label="Move up"><button className="peer …">…</button></Tip>
 */
import type { ReactElement, ReactNode } from 'react';
import { Tooltip, type TooltipSide, type TooltipAlign } from '../../components/ui/tooltip';

export function Tip({
  label,
  children,
  side = 'bottom',
  align = 'center',
  className,
}: {
  label: ReactNode;
  children: ReactNode;
  side?: TooltipSide;
  align?: TooltipAlign;
  className?: string;
}): ReactElement {
  return (
    <span className={`relative inline-flex ${className ?? ''}`}>
      {children}
      <Tooltip side={side} align={align}>
        {label}
      </Tooltip>
    </span>
  );
}
